export default __webpack_public_path__ + "static/media/bg-yellow2-texture.f1b5fe54.jpeg";